import {
  LOGIN_MSISDN_FAIL,
  LOGIN_MSISDN_RESET,
  LOGIN_MSISDN_START,
  LOGIN_MSISDN_SUCCESS
} from './constants';
import { LoginMsisdnActions, LoginMsisdnState } from './types';

const initialState: LoginMsisdnState = {
  loading: false,
  data: undefined,
  error: undefined,
};

const reducer = (
  state = initialState,
  action: LoginMsisdnActions,
): LoginMsisdnState => {
  switch (action.type) {
    case LOGIN_MSISDN_START:
      return {
        ...initialState,
        loading: true,
      };
    case LOGIN_MSISDN_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case LOGIN_MSISDN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case LOGIN_MSISDN_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;
